import { render, staticRenderFns } from "./learningVideo.vue?vue&type=template&id=fd3565f6&scoped=true&"
import script from "./learningVideo.vue?vue&type=script&lang=js&"
export * from "./learningVideo.vue?vue&type=script&lang=js&"
import style0 from "./learningVideo.vue?vue&type=style&index=0&id=fd3565f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd3565f6",
  null
  
)

export default component.exports